import React, { useState, useEffect, useCallback } from 'react';


const MultiSelectContext = React.createContext({});

export const MultiSelectProvider = ({ children }) => {
  const [multiSelected, setMultiSelected] = useState({}),
        [isEnabled, setEnabled] = useState(false),
        isSelected = useCallback((id) => !!multiSelected[id], [multiSelected]),
        toggle = useCallback((id) => {
          setMultiSelected((selected) => {
            const newValue = !selected[id];
            return { ...selected, [id]: newValue };
          });
        }, []),
        toggleEnabled = useCallback(() => {
          setEnabled((wasEnabled) => !wasEnabled);
        }, []),
        selectAll = useCallback((ids) => {
          const all = {};
          ids.forEach((id) => {
            all[id] = true;
          });
          setMultiSelected(all);
        }, []),
        deselectAll = useCallback(() => {
          setMultiSelected(() => ({}));
        }, []);

  useEffect(() => {
    if (!isEnabled) {
      deselectAll();
    }
  }, [deselectAll, isEnabled]);

  return (
    <MultiSelectContext.Provider value={{
      deselectAll,
      isEnabled,
      isSelected,
      multiSelected,
      selectAll,
      setEnabled,
      toggle,
      toggleEnabled,
    }}
    >
      {children}
    </MultiSelectContext.Provider>
  );
};

export const withMultiSelectProvider = (Component) => (props) => (
  <MultiSelectProvider>
    <Component {...props} />
  </MultiSelectProvider>
);

export default MultiSelectContext;
